import { useEffect, useState } from "react";

const KeywordSlot = (props) => {
    const [required, setRequired] = useState(true);
    const [keywordsText, setKeywordsText] = useState('');

    const toggleRequired = () => setRequired(v => !v);

    const updateKeywordsText = (event) => setKeywordsText(event.target.value);

    const updatedStatus = () => {
        if (props.saveStatus == null) return;
        const keywords = keywordsText.split("\n").filter(s => s !== '');
        if (!required) keywords.push('');
        props.saveStatus(keywords);
    }

    useEffect(() => { updatedStatus(); }, [required, keywordsText]);

    useEffect(() => {
        if (props.loadExample) {
            setKeywordsText(props.example.join("\n"));
            setRequired(props.exampleRequired);
        }
    }, [props.loadExample]);

    return (
        <div className="slot">
            <span className="slot-label">Column {props.colIndex}</span>
            <textarea
                className="slot-textarea"
                onChange={updateKeywordsText}
                value={keywordsText}
                placeholder={"One keyword\nper line..."}
            />
            <label className="slot-toggle">
                <span className="toggle-switch">
                    <input type="checkbox" checked={required} onChange={toggleRequired} />
                    <span className="toggle-track" />
                </span>
                <span className="toggle-label">{required ? 'Required' : 'Optional'}</span>
            </label>
        </div>
    );
}

export default KeywordSlot;
